// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-buttons{margin:auto;text-align:center;margin-bottom:10px}.justRegistered-dialog{background-color:#9ccc65;color:#000;width:100%;margin:auto;padding:2px}", ""]);
// Exports
module.exports = exports;
